/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_CnpjInputs */

const en_clients_field_cnpj = /** @type {(inputs: Clients_Field_CnpjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNPJ`)
};

const pt_br2_clients_field_cnpj = /** @type {(inputs: Clients_Field_CnpjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNPJ`)
};

/**
* | output |
* | --- |
* | "CNPJ" |
*
* @param {Clients_Field_CnpjInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_cnpj = /** @type {((inputs?: Clients_Field_CnpjInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_CnpjInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_cnpj(inputs)
	return pt_br2_clients_field_cnpj(inputs)
});